import useMediaQuery from '../hooks/useMediaQuery';

export const useIsSmall = () => useMediaQuery('(max-width: 480px)');
export const useIsMedium = () => useMediaQuery('(max-width: 960px)');
export const useIsLarge = () => useMediaQuery('(min-width: 960px)');
